/* eslint-disable no-undef */
import {
    API,
    SITE_API,
    USERS_GET_ALL_URL,
    USER_CHANGE_PASSWORD_URL,
    USER_CHANGE_STATUS_URL,
    USER_DELETE_URL,
    USER_ADD_NEW_URL,
    USER_UPDATE_URL,
    USERS_DELETE_SELECTED_URL
} from "../variable";

import axios from 'axios'
import {
    USERS_GET_ALL,
    USER_CHANGE_PASSWORD,
    USER_CHANGE_STATUS,
    USER_DELETE,
    USER_ADD_NEW,
    USER_UPDATE,
    USERS_DELETE_SELECTED
} from "../Actions/users";

function validatePayloadData(payload) {
    const formData = new FormData();
    if (payload) {
        for (const key in payload) {
            if (payload[key] !== null && payload[key] !== undefined) {
                if (Array.isArray(payload[key])) {
                    payload[key].forEach((item, index) => {
                        formData.append(`${key}[${index}]`, item);
                    });
                } else {
                    formData.append(key, payload[key]);
                }
            }
        }
    }
    return formData;
}

const state = {
    users: [],
    usersPagination: {},
    loading: false,
    error: null
};

const actions = {
    [USERS_GET_ALL]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: payload.url_type == 'init' ? SITE_API + getters.get_crm_prefix + USERS_GET_ALL_URL : payload.next_page_url,
            method: "POST",
            data: validatePayloadData(payload),
            headers: { 'Authorization': 'Bearer ' + sessionStorage.authToken }
        });
    },

    [USER_CHANGE_PASSWORD]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: SITE_API + getters.get_crm_prefix + USER_CHANGE_PASSWORD_URL,
            method: "POST",
            data: validatePayloadData(payload),
            headers: { 'Authorization': 'Bearer ' + sessionStorage.authToken }
        });
    },

    [USER_CHANGE_STATUS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: SITE_API + getters.get_crm_prefix + USER_CHANGE_STATUS_URL,
            method: "POST",
            data: validatePayloadData(payload),
            headers: { 'Authorization': 'Bearer ' + sessionStorage.authToken }
        });
    },

    [USER_DELETE]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: SITE_API + getters.get_crm_prefix + USER_DELETE_URL,
            method: "POST",
            data: validatePayloadData(payload),
            headers: { 'Authorization': 'Bearer ' + sessionStorage.authToken }
        });
    },

    [USER_ADD_NEW]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: SITE_API + getters.get_crm_prefix + USER_ADD_NEW_URL,
            method: "POST",
            data: validatePayloadData(payload),
            headers: {
                'Authorization': 'Bearer ' + sessionStorage.authToken,
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    [USER_UPDATE]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: SITE_API + getters.get_crm_prefix + USER_UPDATE_URL,
            method: "POST",
            data: validatePayloadData(payload),
            headers: { 'Authorization': 'Bearer ' + sessionStorage.authToken }
        });
    },



    [USERS_DELETE_SELECTED]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: SITE_API + getters.get_crm_prefix + USERS_DELETE_SELECTED_URL,
            method: "POST",
            data: validatePayloadData(payload),
            headers: { 'Authorization': 'Bearer ' + sessionStorage.authToken }
        });
    }
};

const mutations = {
    SET_USERS(state, users) {
        state.users = users;
    },
    SET_USERS_PAGINATION(state, pagination) {
        state.usersPagination = pagination;
    },
    SET_LOADING(state, loading) {
        state.loading = loading;
    },
    SET_ERROR(state, error) {
        state.error = error;
    },
    ADD_USER(state, user) {
        state.users.unshift(user);
    },
    UPDATE_USER(state, updatedUser) {
        const index = state.users.findIndex(user => user.id === updatedUser.id);
        if (index !== -1) {
            state.users.splice(index, 1, updatedUser);
        }
    },
    REMOVE_USER(state, userId) {
        state.users = state.users.filter(user => user.id !== userId);
    }
};

const getters = {
    getAllUsers: state => state.users,
    getUsersPagination: state => state.usersPagination,
    isUsersLoading: state => state.loading,
    getUsersError: state => state.error,
    getUserById: state => id => state.users.find(user => user.id === id),
    getStudents: state => state.users.filter(user => user.type === 'student'),
    getInstructors: state => state.users.filter(user => user.type === 'instructor'),
    getActiveUsers: state => state.users.filter(user => user.status === 'active'),
    getInactiveUsers: state => state.users.filter(user => user.status === 'inactive')
};

export default {
    state,
    getters,
    actions,
    mutations
}; 